import React from "react";
import "./blogs.css";


const Aditya_Gupta = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src="placement-postulates/dp/Aditya-Gupta.jpg"
            style={{ height: "315px", width: "90%" }}
            alt="aditya"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Aditya Gupta </h2>
            <small>Software Engineer Square Point, Montreal</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction and Initial Journey</h3>
            <p>
              Hello everyone, I am Aditya Gupta, a Y19 BT/CE student, and I will
              be joining Squarepoint Capital as a Software Engineer in Montreal.
              Over the past four years of my journey at IIT Kanpur, I have seen
              a lot of ups and downs. Many things happened during these four
              years and placements were undoubtedly one of the most significant
              moments, for many of you, that would be the same.
            </p>

            <p>
              So let me start with some background first. I didn't secure any
              internship from the SPO in my third year, and neither I tried
              off-campus placements. My cpi was 8.2, and over the years, I was
              focussed on my academics and was involved with clubs and the SNT
              council.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Aditya-Gupta/2.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>
              Internship Semester: Struggles and Getting Selected at SquarePoint
              Capital
            </h3>
            <p>
              After the internship season, I learned a lot about how and what
              are important things which needs to be considered while placements
              preparation. My preparations began in June 2022 as I had no
              internships, so I focused on learning DSA and practicing
              interviewbit questions. However, I had a basic understanding of
              DSA as I had done it during the internship season, so I started
              directly with the questions, which was a terrible idea. For all of
              you , I would suggest starting with Striver's SDE Sheet as it's
              excellent if you some basic understanding of DSA and it provides a
              systematic and organized way of learning. Also, if you are someone
              who hasn't worked on anything related to software development, get
              some hands-on experience with it (because companies nowadays
              expect that too).
            </p>
            <p>
              The resume is one of the most important aspects of the placements,
              and you must need to have a proper resume. I did not struggle with
              my resume as I had learnt my lessons in the internship drive and
              had a well-defined resume. Also, due to my involvement with
              different clubs and some course projects, I had pretty decent
              projects in my resume, including an Inter IIT Techmeet project. So
              my advice is to get your resume sorted as soon as possible and
              remember to write each point nicely, be specific with numbers, and
              highlight them too. Also, it would be nice if your resume differs
              from others in design, projects, or anything, as it gets noticed
              easily. And be aware that what you write should be unique in the
              sense that not Everyone has that certain point/project.
            </p>
            <p>
              I was also sure that I would be sitting in either SDE or
              ML/Analytics roles as I had experienced only related to them, and
              my interest also lies within them. This made my preparations a
              little simple, and thus, I need to focus on CP, Aptitude, Puzzles
              and Probability. For CP, as described earlier, I started with
              interviewbit, then shifted towards leetcode. I found leetcode much
              better as it had a nice interface along with daily random
              questions and weekly tests, which I tried to give, and they were
              important as they helped you in allocating time for solving the
              questions as the real test ,more or less have the same time and a
              per the difficulty level.
            </p>
           
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Placement semester:</h3>
            <p>
              One of the most crucial aspects of preparation, which people often
              neglect, is preparing for interviews or mock interviews. You
              should give atleast five to ten mock interviews with your friend,
              and if you can, buy an online mock interview (as this helped a
              lot). Since I had given around 2 to 3 interviews in the internship
              drive, I was pretty sure how the interviews would take place. One
              thing to remember during interview preparations is to prepare your
              speaking skills to be comfortable during the interviews and be
              able to answer properly. So after everything, finally, the
              placement drive kick-started, and till Mid-October, the frequency
              of the tests was less, so it provided time to organize myself and
              practice questions daily. The key here was consistency. In
              November, the test frequency shot up dramatically, and there was
              no time in between to practice, and this was also when the
              interview shortlist started coming. I was not shortlisted by any
              of the companies initially, as those were the tests in which I
              didn't do well or the company shortlisted based on branch. Still,
              after some time, I was shortlisted for five to six companies,
              including Pinelabs, Standard Chartered and Capital One.
              Squarepoint Capital was the one which came quite late, but since
              its test wasn't typical DSA and was more understanding based, I
              was able to clear it comfortably. Thus I was shortlisted for two
              companies, Squarepoint Capital and Capital One, on Day 1.1.
            </p>
            <p>
              Around 27th November, my endsems were over, and I started revising
              everything. Since I was shortlisted in Squarepoint Capital as a
              Python developer, I studied Python more exhaustively (as I have
              shifted from C++ to Python for placement tests as it was faster to
              write code in Python rather than C++, which is also different from
              others). Also, since I didn't study CS fundamentals earlier, it
              was essential to do it now. Thus, I divided my time between
              learning CS fundamentals and Python, doing Strive's SDE sheet and
              two mock interviews I had purchased. Also, I talked to other
              seniors working in Squarepoint Capital to learn about the
              interview process and was proceeding accordingly. Although I
              didn't have much expectations due to my CPI and branch, I still
              gave my all.
            </p>
          </div>
        </div>

        <br />
        <br />
        <br />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Day 1.1 of Placements</h3>
            <p>
              Day1.1 - Before the Day could start at midnight, we were added to
              the Whatsapp Group for the interviews, and the interview slots
              were shared with us. And since my interview for the Squarepoint
              Capital wasn’t scheduled before 4 am. I was relaxed, but suddenly
              a call came around 10:30 pm and informed me that my other company,
              where I was shortlisted, Capital One, had decided to take a test
              before the interviews. Thus the test was scheduled for 11 pm, and
              I needed to reach the tutorial blocks fully dressed up. I
              immediately got dressed and ran over there and gave the test. This
              test was very important to me as this was the test that gave me
              the confidence boost that I needed before the interviews because I
              wasn’t sure about my ability to solve DSA questions in interviews
              despite having done so much practice as I wasn’t able to do them
              in my mock interviews. But I was satisfied since I could do the
              questions in these tests despite being medium to difficult, and
              thus my confidence shot up. I went to Hall 12 for the interviews
              since the slots for Capital One were still unknown, and my
              interview with Squarepoint Capital could happen if someone is
              currently unavailable or if they are occupied elsewhere. I was
              waiting and suddenly, around 1 pm, I got the chance for an
              interview in Squarepoint Capital for the SDE role.
            </p>
            <img
              class="blog-image-left"
              src="placement-postulates/blogs/Aditya-Gupta/3.jpg"
            />
            <h3>Squarepoint Capital | ROUND 1 (10-15 minutes)</h3>
            <p>
              This was a type of rapid-fire round where questions were asked
              regarding my resume and some basic questions related to React.
              There was also one question where I needed to write the code to
              separate the floating part from the integer part. After the
              interview, I was immediately told to join for the next round.{" "}
            </p>
            <h3>Squarepoint Capital | ROUND 2 (30-40 minutes)</h3>
            <p>
              In this round, I was asked to solve a question where I had to
              write a function to differentiate a polynomial question covering
              all edge cases. After that, there were a series of questions
              related to Python, DBMS, Networking, and Operating Systems, and
              since I was well-versed in them, I answered all of them. One such
              question which I remember was to explain database normalization. I
              was very satisfied with the interview, and as before, I was
              immediately called for the next round.
            </p>
            <h3>Squarepoint Capital | ROUND 3 (40-60 minutes)</h3>
            <p>
              This was the final round, and it was with one of the founding
              members at Squarepoint Capital. This round was much more
              exhaustive than the previous rounds, where I was asked questions
              related to my resume and projects. These were much more detailed
              questions requiring an understanding of every project, what I have
              done, and why. Since I was prepared for them, it was simple for
              me. There were also questions related to Networking where the
              concepts were asked in more detail and required a thorough
              understanding of them. All in all, it was the longest round, but
              it was the deciding factor, and after this round, I was hoping for
              the final selection.
            </p>

            <h3>RESULTS</h3>
            <p>
              Eventually, after the interviews were over, shortly after I was
              informed by the Squarepoint Captial’s HR that I had been
              shortlisted, since before the placements interview in the Google
              form regarding the preferences, I filled out Squarepoint Capital
              above Capital One, there was no need to give the interviews for
              Capital One, and thus my placement season came to an end at around
              2:30 am.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Aditya-Gupta/4.jpg"
        />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Placement Tips:</h3>
            <p>
              The first tip is to be humble at every point in time. Try to
              motivate yourself and always look at the bright side, and if you
              can’t find a bright side, don’t try to underestimate yourself. The
              placement season could be very cruel. At one point, you might
              start to lose hope, but that is when you need to motivate
              yourself. Confidence is the key, and keep your friends together or
              have someone with whom you can share your pain. Friends would be
              the ones who would be with you and your side as they are also in
              the same boat as you. And remember that this is not the end. Mock
              interviews are very important along with your resume along with
              your preparation to defend each and every point in your resume.
              It’s okay not to know something, but telling your thought process
              might be the key, which you only get to know after giving mock
              interviews. Also, if you are sitting for SDE interviews, be ready
              with system design concepts, as many companies want candidates
              with hands-on software development experience along with DSA.
              Results are a part of the process, but the process is essential.
              Many factors influence results and are something which you can’t
              control, but the process is, and consistency would be important.
              Build your self-confidence and connections, and be patient. And
              remember **<b>Sometimes good things come to those who wait</b>**.
            </p>
            <p>
              I have tried to cover everything as far as I can think of.
              Nevertheless, if any of you want to contact me regarding any`
              queries, feel free to do so, I would be happy to help. And also,
              don’t be shy in asking questions to your seniors, as they will
              definitely try to help you in any way they can
            </p>
            <p>Best of luck, everyone, for your future endeavors.</p>
            <p>
              <ul>
                <li>
                  <b>Resume:</b>{" "}
                  <a
                    href="https://drive.google.com/file/d/1WmmaDyt0szlfSOc7HZjJOqMdvDxz3nkN/view"
                    className="resume-link"
                  >
                    [View Resume]
                  </a>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aditya_Gupta;
